import React from 'react';

/**
 * ConveyorShell - Fixed bottom conveyor belt container
 * 
 * Pinned to bottom of viewport with conveyor belt background.
 * Accepts children (baskets) for organization-grouped prop selection.
 * 
 * @param {React.ReactNode} children - Basket components to render
 */
const ConveyorShell = ({ children }) => {
  return (
    <div 
      className="fixed right-0 z-40 pointer-events-none transition-all duration-200 ease-linear"
      style={{ 
        height: 'clamp(200px, 35vh, 280px)',
        bottom: 'var(--sidebar-height-mobile-icon)', // Mobile: sit on top of drawer
        left: 'var(--sidebar-width-icon)', // Desktop: pushed by sidebar
      }}
    >
      {/* Background conveyor belt image */}
      <div 
        className="absolute bottom-0 inset-x-0 bg-center"
        style={{
          height: 'clamp(40px, 7vh, 54px)',
          backgroundImage: "url('/images/bottom_shell/cbv_long_short.png')",
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
        }}
      />
      
      {/* Content container - positioned at bottom but doesn't block full height */}
      <div className="absolute bottom-0 left-0 right-0">
        <div className="w-full pb-8">
          {/* Children have pointer events enabled */}
          {children}
        </div>
      </div>
    </div>
  );
};

export default ConveyorShell;
